import { Column, Grid, MainSection, Row, ShellLayout } from 'cdk-radial';
import styled, { css } from 'styled-components';
import { StyledDivProps } from './types';

const intFrameHeight = window.innerHeight;

export const StyledBackground = styled.div`
  border-radius: 8px 8px 0px 0px;
  border: 1px;
  height: ${intFrameHeight}px;
  max-height: ${intFrameHeight - 108}px;
  overflow-y: scroll;
  padding-top: 4px;
`;

export const StyledMainSection = styled(MainSection)`
  height: ${intFrameHeight}px;
  max-height: ${intFrameHeight}px;
  padding: 12px;
`;

export const MARGIN = {
  ALL: '5px',
  LEFT_ONLY: '0 0 0 5px',
  RIGHT_ONLY: '0 5px 0px 0px',
  TOP_LEFT: '5px 0 0 5px',
  TOP_RIGHT: '5px 5px 0 0'
};

export const BORDER_RADIUS = {
  NONE: 'none',
  TOP: '8px 8px 0 0'
};

export const StyledDiv = styled.div<StyledDivProps>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding:"0px"

  ${({ variant }) =>
    (variant === 'LEFT_CARD' &&
      css`
        background-color: transparent;
        border: none;
        flex-direction: row;
        margin: ${MARGIN.ALL};
        padding-top: 15px;
        padding: 0px;
      `) ||
    (variant === 'TABLE_CARD' &&
      css`
        align-items: center;
        background-color: transparent;
        border: none;
        flex-direction: row;
        margin: ${MARGIN.ALL};
        padding: 0px;
      `) ||
    (variant === 'RIGHT_MAIN_CARD' &&
      css`
        border-bottom: none;
        border-radius: ${BORDER_RADIUS.TOP};
        margin: ${MARGIN.TOP_LEFT};
        text-align: -webkit-right;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
      `) ||
    (variant === 'FOOTER_CARD' &&
      css`
        border-bottom: none;
        border-radius: ${BORDER_RADIUS.TOP};
        margin: ${MARGIN.TOP_LEFT};
        text-align: -webkit-right;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 12px;
      `)}
      }
    `;

export const StyledColumn = styled(Column)`
  display: flex;
  flex-direction: column;
  max-height: 100px;
`;

export const StyledRow = styled(Row)`
  padding: 2px 2px 2px 12px;
`;

export const StyledShellLayout = styled(ShellLayout)`
  flex: 1;
`;

export const StyledGrid = styled(Grid)`
  flex: 1;
`;

export const StyledSkeletonRow = styled(Row)`
  display: flex;
  justify-content: space-between;
`;

export const StyledSkeletonColumn = styled(Column)`
  margin: 0 10px;
`;
